import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import Spin from '../../components/loading';
import ShowForPermission from '../../components/ShowForPermission';
import Pagination2 from '../../components/Pagination2';
import CheckoutTable from './checkoutTable';
import CheckoutFilter from './checkoutFilter';

import * as reserveActions from '../../redux/reservations/actions';
import submitForm from '../../utils/submitForm';
import ENUMS from '../../enums';

class ReserveCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: '',
      sort: '',
      query: '',
      cafeId: '',
      currentPage: 1,
      itemsPerPage: 10,
      sortType: 'desc',
      sortBy: 'createdAt',
      checkoutOrClientAbsentReservesList: []
    };
  }

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllCheckedoutOrClientAbsentReserves(searchQuery);
    });
  };

  onSelectCafeIds = cafeId => this.setState({ cafeId });

  applyFilters = event => {
    const queryString = submitForm(event, this.state.selectedRegions, this.state.selectedAmenities);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      console.log('pageNumber is: ', pageNumber);
      console.log('pageSize is: ', pageSize);
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllCheckedoutOrClientAbsentReserves(query);
    });
  };

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  render() {
    const {
      checkoutOrClientAbsentReservesLoading,
      checkoutOrClientAbsentReservesFailed,
      checkoutOrClientAbsentReservesError,
      checkoutOrClientAbsentReservesMessage
    } = this.props;

    let { totalRecords } = this.props.checkoutOrClientAbsentReserves;
    const { currentPage, itemsPerPage, sortType, checkoutOrClientAbsentReservesList } = this.state;

    return (
      <section className="p-1 col-12">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-muted py-4">
            <div className="text-right">{locales('titles.settelmentManagement')}</div>
          </h3>
          <ShowForPermission permission={ENUMS.PERMISSIONS.values.NEW_CHECKOUT_WITH_CAFE}>
            <div>
              <NavLink
                to={{
                  pathname: '/reserve/checkout/add-or-edit',
                  editMode: false
                }}
              >
                <button className="btn btn-primary w-5 mx-1">
                  <i className="fal fa-plus mx-1" />
                  {locales('labels.new')}
                </button>
              </NavLink>
            </div>
          </ShowForPermission>
        </div>
        <Spin spinning={checkoutOrClientAbsentReservesLoading}>
          <article>
            <main className="panel panel-default">
              {checkoutOrClientAbsentReservesError ? (
                <div className="alert alert-danger">{locales('messages.server.error')}</div>
              ) : (
                <>
                  {checkoutOrClientAbsentReservesFailed && (
                    <div className="alert alert-danger">{checkoutOrClientAbsentReservesMessage}</div>
                  )}
                  <div className="panel-heading">
                    <i className="fas fa-list-alt px-1" />
                    {locales('titles.settelmentsList')}
                  </div>
                  <div className="panel-body">
                    <CheckoutFilter
                      applyFilters={this.applyFilters}
                      filterAndSort={this.filterAndSort}
                      onSelectCafeIds={this.onSelectCafeIds}
                      pageNumber={this.state.currentPage}
                    />
                    <CheckoutTable
                      pageNumber={currentPage || 0}
                      sortTable={this.sortTable}
                      pageSize={itemsPerPage || 10}
                      sortType={sortType}
                    />
                    <footer className="col-12 d-flex justify-content-center py-2">
                      <div className="pagination-container">
                        <Pagination2
                          totalRecords={totalRecords || 0}
                          pageLimit={itemsPerPage}
                          pageNeighbours={2}
                          onPageChanged={this.onPageChanged}
                          currentPage={this.state.currentPage}
                        />
                      </div>
                    </footer>
                  </div>
                </>
              )}
            </main>
          </article>
        </Spin>
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    checkoutOrClientAbsentReservesLoading: state.reservationsReducer.checkoutOrClientAbsentReservesLoading,
    checkoutOrClientAbsentReservesFailed: state.reservationsReducer.checkoutOrClientAbsentReservesFailed,
    checkoutOrClientAbsentReservesError: state.reservationsReducer.checkoutOrClientAbsentReservesError,
    checkoutOrClientAbsentReservesMessage: state.reservationsReducer.checkoutOrClientAbsentReservesMessage,
    checkoutOrClientAbsentReservesList: state.reservationsReducer.checkoutOrClientAbsentReservesList,
    checkoutOrClientAbsentReserves: state.reservationsReducer.checkoutOrClientAbsentReserves
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllCheckedoutOrClientAbsentReserves: query =>
      dispatch(reserveActions.fetchAllCheckedoutOrClientAbsentReserves(query))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReserveCheckout);
